// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"CollectionsPage_pageContainer__2-ykG","lineupContainer":"CollectionsPage_lineupContainer__1Atjr","spinner":"CollectionsPage_spinner__BEufs"};